import { getFilteredData, getSortedData } from '../../../List/helper';
export const getFilteredUsers = ({ users, filterKey }) => {
    return getFilteredData({ data: users, filterKey })
}
export const getSortedUsers = ({ users, sort }) => {
    return getSortedData({ data: users, sort })
} 